"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("auto-widget-framework/src/Error/WidgetError");
class FormValuesToObjectTransformer {
    /**
     * @inheritDoc
     */
    to(form) {
        const values = {};
        for (let i = 0; i < form.length; i++) {
            const element = form.elements[i];
            if (!element.name) {
                continue;
            }
            const value = this.getElementValue(element);
            if (value === undefined || value === null || value === "") {
                continue;
            }
            const nameParts = element.name.match(/.+?(?=[\[\(]|$)/gm);
            let level = values;
            let lastLevel;
            let namePart;
            for (let j = 0; j < nameParts.length; ++j) {
                namePart = j === 0 ? nameParts[j] : nameParts[j].slice(1, -1);
                if (namePart === "") {
                    const previousNamePart = j - 1 === 0 ? nameParts[j - 1] : nameParts[j - 1].slice(1, -1);
                    if (!Array.isArray(lastLevel[previousNamePart])) {
                        lastLevel[previousNamePart] = [];
                        level = lastLevel[previousNamePart];
                    }
                }
                else {
                    level[namePart] = level[namePart] || {};
                    lastLevel = level;
                    level = level[namePart];
                }
            }
            if (Array.isArray(level)) {
                level.push(value);
            }
            else {
                lastLevel[namePart] = value;
            }
        }
        return values;
    }
    getElementValue(element) {
        let wasDisabled = false;
        if (element.hasAttribute("disabled")) {
            element.removeAttribute("disabled");
            wasDisabled = true;
        }
        let value = element.value;
        if (element.type == "checkbox" || element.type == "radio") {
            if (!element.checked) {
                value = null;
            }
        }
        else if (element.type === "number") {
            if (element.validity.valueMissing && !element.validity.badInput) {
                value = null;
            }
            else if (element.validity.badInput && value === "") {
                value = "NaN";
            }
            else {
                value = Number.parseFloat(value);
            }
        }
        if (wasDisabled) {
            element.setAttribute("disabled", "");
        }
        return value;
    }
    /**
     * @inheritDoc
     */
    from(form) {
        throw new WidgetError_1.default(`Impossible conversion.`);
    }
}
exports.default = FormValuesToObjectTransformer;
